<template>
    <div component="Thumbnail" @click="click" v-click-outside="clickOutside">
        <i class="icon buttons" :class="{ visible: showButtons }" @click="showButtons = !showButtons">edit</i>

        <transition name="question">
            <div v-if="showButtons && !removeQuestion" class="question">
                <i class="icon drag handle">import_export</i>
                <i class="icon edit" @click.stop="edit">crop</i>
                <i class="icon remove" @click.stop="remove">close</i>
            </div>
        </transition>

        <transition name="question">
            <div v-if="removeQuestion" class="question question-delete">
                <label>Delete?</label>
                <btn tpos="none" size="icon" color="white" :icon="'done'" @click="remove"></btn>
            </div>
        </transition>

        <img :src="image.url" alt="" :class="{ deleting }" />
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import PageHeader from '@/components/Profile/ProfileDetailHeader.vue';
import ClickOutside from 'vue-click-outside';

export default {
    name: 'Thumbnail',

    data() {
        return {
            removeQuestion: false,
            deleting: false,
            showButtons: false,
        };
    },

    methods: {
        click() {
            this.$emit('click', this.index);
        },

        edit() {
            this.$emit('edit', this.index);
        },

        remove() {
            this.deleting = true;

            if (!this.removeQuestion) {
                this.removeQuestion = true;

                setTimeout(() => {
                    this.removeQuestion = false;
                    this.deleting = false;
                }, 4000);
            } else {
                this.$emit('remove', this.image);
            }
        },

        clickOutside() {
            this.showButtons = false;
            this.removeQuestion = false;
        },
    },

    props: {
        index: {
            type: Number,
        },

        image: {
            type: Object,
            required: true,
        },
    },

    components: {},

    directives: {
        ClickOutside,
    },
};
</script>
<style lang="less" scoped>
@import '~@variables';

[component='Thumbnail'] {
    position: relative;
    width: 33.33%;
    .flex-center;
    cursor: pointer;

    &:hover {
        .icon {
            opacity: 1;
            visibility: visible;
        }
    }

    .question-enter,
    .question-leave-to {
        opacity: 0;
        transform: scale(0.5);
        position: absolute !important;
        overflow: hidden;
    }

    .question-enter-active,
    .question-leave-active {
        transition: all 0.3s;
    }

    .zoomOut-enter-active {
        transition-delay: 0.15s;
    }

    .question-enter-to {
        opacity: 1;
        transform: scale(1);
        position: absolute !important;
    }

    .question {
        position: absolute;
        top: 4%;
        left: 4%;
        width: 92%;
        height: 92%;
        border-radius: 50%;
        background-color: fade(black, 50%);
        color: white;
        .flex-center;
        flex-direction: row;

        &.question-delete {
            flex-direction: column;
        }

        label {
            font-weight: 900;
            margin-bottom: 5px;
        }

        button {
            margin-bottom: 5px;
        }
    }

    .icon {
        width: 30px;
        height: 30px;
        z-index: 100;
        .flex-center;
        visibility: hidden;
        opacity: 0;
        transition: 0.5s;
        cursor: pointer;

        &:hover {
            color: @primary;
        }

        &.visible {
            opacity: 1;
            visibility: visible;
        }
    }

    .buttons {
        top: 0;
        position: absolute;
        cursor: pointer;
        right: 0;
        font-size: 20px;
        color: @dark;

        &:hover {
            color: #000;
        }
    }

    .drag,
    .edit,
    .remove {
        opacity: 1;
        color: @white;
        line-height: 30px;
        text-align: center;
        visibility: visible;
        display: inline-block;
    }

    .remove {
        &:hover {
            color: @accent;
        }

        &.accept {
            color: @accent;
            transform: translateY(-3px);
        }
    }

    .edit {
        font-size: 18px;
    }

    img {
        width: calc(100% - 8px);
        height: calc(100% - 8px);
        border: 3px solid #c4c5c6;
        border-radius: 50%;
        transition: 0.3s;
        margin: 4px;

        @media (orientation: landscape) {
            // width: 13vw;
            // height: 13vw;
            // max-width: 135px;
            // max-height: 135px;
        }

        &.deleting {
            // opacity: .5;
            border-color: @accent;
        }
    }
}
</style>
